var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"stt-button",attrs:{"type":"button"},on:{"click":function($event){_vm.isListening ? _vm.stopListening() : _vm.startListening()}}},[_c('img',{staticClass:"stt-icon",class:{ 'listening': _vm.isListening },attrs:{"src":_vm.micIconSrc}})])
}
var staticRenderFns = []

export { render, staticRenderFns }